import React, { useEffect, useState } from "react";
import CallAPI from "../../../../adminpanel/components/commonComponents/AxiosHelper";
import { connect } from 'react-redux';
import DataTableComponent from "../../commonComponents/DataTableComponent";
import LoadingComponent from '../../commonComponents/LoadingComponent';
import { Link } from 'react-router-dom';
import { FixModal, FixModalDropDownEvent } from "./FixModal";
import ModalComponent from '../../../../adminpanel/components/commonComponents/ModalComponent';
import Form from '../../../../adminpanel/components/commonComponents/Form.v2';

//import BreadCrumb from '../../../../adminpanel/components/commonComponents/BreadCrumb';

const APIRequest = ({ authData, match }) => {

    const [requestData, setRequestData] = useState(null)
    const [modalToView, setmodalToView] = useState({})
    const [dataToSend, setdataToSend] = useState({})
    const [dropDownVal, setdropDownVal] = useState("")
    let urlParams = match.params;

    const formData = {
        "current_status": {
            "name": "current_status", "type": "dropdown", "text_value": dropDownVal, "options": [
                { "name": "Select Status", "value": "" },
                { "name": "All", "value": "" },
                { "name": "Completed", "value": "3" },
                { "name": "Processing", "value": "1" },
                { "name": "Pending", "value": "0" },
                { "name": "Failed", "value": "2" }
            ]
        }
    }

    useEffect(() => {
        getInitialData();
    }, [])

    function handleChange(e) {
        setdropDownVal(e.target.value);
        getInitialData(e.target.value)
    }

    function getInitialData(val = null) {
        setRequestData(null);
        let params = null;
        let requested_from = urlParams.requested_from
        if (val) {
            params = { "siteId": authData.siteId, "requested_from": `${requested_from}`, "status": val };
        } else {
            params = { "siteId": authData.siteId, "requested_from": `${requested_from}` };
        }
        // params['user'] = authData.userId;
        if (requested_from == 'app') {
            params['toolId'] = authData.toolId;
        }

        let postData = {
            low: 0,
            limit: 20,
            user: authData.userId
        }
        CallAPI('POST', '/app/get_api_request', postData, params, 0, function (response) {
            // response = decodeResponseBody(response)
            checkIfMaintenanceModeOn(response)
            if (response.status === true) {
                setRequestData(response.information);
            } else {
                setRequestData(null);
            }
        }, authData)
    }

    function refershButtonEvent() {
        getInitialData(dropDownVal);
    }

    function handleFix(row) {
        FixModal(row, setmodalToView, setdataToSend);
    }

    function handleModalDropDown(e) {
        FixModalDropDownEvent(e, dataToSend, modalToView, setmodalToView, authData);
    }

    const handleDownload = (row) => {
        let url = '/app/download_data_quality_report'
        let postData = { "rm_request_id": row.id, userId: authData.userId }
        let params = {
            siteId: authData.siteId
        }
        let responseType = "blob";
        alert("Your report will be opened soon in new tab")
        CallAPI('POST', url, postData, params, 0, function (response) {
            if (responseType == "blob") {
                // //Build a URL from the file
                // const fileURL = window.URL.createObjectURL(response);
                // //Open the URL on new Window
                // window.open(fileURL);
                let binaryData = [];
                binaryData.push(response);
                const fileURL = window.URL.createObjectURL(new Blob(binaryData, { type: "application/pdf" }))
                window.open(fileURL);
            }
        }, authData, responseType);
    }

    function modalSubmission(e) {
        let sampleModalData = { ...modalToView }
        let params = {
            siteId: authData.siteId,
            user: authData.userId,
            userId: authData.userId,
            auth: "system"
        }
        let target = e.target.name;
        $(`#${target}Form`).serializeArray().map((innerData) => {
            dataToSend['pull_information'][0][innerData.name] = innerData.value;
        })
        if (dataToSend['pull_information'][0]['overwriteType']) {
            if (dataToSend['pull_information'][0]['overwriteType'] === "full") {
                dataToSend['pull_information'][0]['overwriteCondition']['fileName'] ? delete dataToSend['pull_information'][0]['overwriteCondition']['fileName'] : null
                dataToSend['pull_information'][0]['overwriteCondition'] = { "entire": true }
            } else if (dataToSend['pull_information'][0]['overwriteType'] === "file") {
                dataToSend['pull_information'][0]['overwriteCondition'] = { "fileName": [dataToSend['pull_information'][0]['fileName']] }
            }
            dataToSend['pull_information'][0]["action"] = "overwrite";
            delete dataToSend['pull_information'][0]['fileName']
            delete dataToSend['pull_information'][0]['overwriteType']
        }

        dataToSend['api_request'] = true
        let postData = dataToSend;

        if (dataToSend['file_case']) {
            postData = new FormData();
            Object.keys(dataToSend['pull_information'][0]).map(function (innerData) {
                let dataToAdd = typeof (dataToSend['pull_information'][0][innerData]) == "object" ? JSON.stringify(dataToSend['pull_information'][0][innerData]) : dataToSend['pull_information'][0][innerData]
                if (dataToAdd && dataToAdd != "null")
                    postData.append(innerData, dataToAdd)
            })
            postData.append('api_request', dataToSend['api_request'])
            postData.append('request_id', dataToSend['request_id'])
            postData.append('rm_backend_process', dataToSend['rm_backend_process'])
        }

        let url = '/app/system/pullClientData_v1';

        sampleModalData.modal['isLoading'] = true
        sampleModalData.modal['formKey'] = `fixDataForm_${Math.floor(Math.random() * 10)}`;
        setmodalToView(sampleModalData);

        CallAPI('post', url, postData, params, 0, function (response) {
            let tempInfo = response.information;
            if (tempInfo[0].status === true) {
                alert(tempInfo[0].information);
            } else {
                alert(tempInfo[0].error_message);
            }
            jQuery('#fixDataModal').modal('toggle');
        }, authData);
        e.preventDefault();
    }

    let displayModal = null
    let filterForm = Object.keys(modalToView).length > 0 ? <Form label_array={modalToView.formData} handle_form_drop_down={handleModalDropDown} /> : null;
    Object.keys(modalToView).length > 0 ? modalToView.modal['body'] = filterForm : null;
    displayModal = modalToView.modal && Object.keys(modalToView.modal).length > 0 ? <ModalComponent modalConfig={modalToView.modal} formSubmit={modalSubmission} /> : null;

    let columnData = [
        { "virtualName": "Request Name", "rawField": "request_name" },
        {
            "virtualName": "Status", "rawField": "current_status", type: "tableCell", tableCell: (row, id, column, index) => {
                return <>
                    {
                        row["current_status"] == "3" ? <span className="badge badge-success">Completed</span> :
                            row["current_status"] == "1" ? <span className="badge badge-info">Processing</span> :
                                row["current_status"] == "2" ? <span className="badge badge-danger">Failed</span> :
                                    row["current_status"] == "0" ? <span className="badge badge-warning">Pending</span> :
                                        null
                    }
                </>
            }
        },
        { "virtualName": "Update Time", "rawField": "last_updated_time" },
        {
            "virtualName": "Last Status", "rawField": "comment", type: "tableCell", tableCell: (row, id, column, index) => {
                var isValidJSON = row['comment'] ? true : false
                try { JSON.parse(row['comment']) } catch (e) { isValidJSON = false }
                let comment = isValidJSON ? JSON.parse(row['comment']).message : row['comment']
                return <>
                    {comment}
                </>
            }
        },
        {
            "virtualName": "View", "rawField": "requested_time", "centerAlign": true, type: "tableCell", tableCell: (row, id, column, index) => {
                if (row['category'] == "Data Upload") {
                    let rawData = JSON.parse(row['post_body']);
                    let DBName = `customer_${row['siteId']}_file_uploaded`;
                    let tableName = rawData['pull_information'][0].virtualTableName ? rawData['pull_information'][0].virtualTableName.toLowerCase().replace(/[ -]/gi, "_") : null;
                    if (rawData["pull_information"][0].targetTable) {
                        let splitData = rawData["pull_information"][0].targetTable.split('.');
                        if (splitData.length > 1) {
                            DBName = splitData[0]
                            tableName = splitData[1]
                        } else tableName = splitData[0]
                        tableName = tableName.toLowerCase().replace(/[ -]/gi, "_")
                    }
                    let connectionId = rawData['pull_information'][0].connectionId;
                    return <>
                        {row["current_status"] == "2"
                            ? row['error_code'] && row['error_code'] !== null && (["620", "611", "622", "615"].indexOf(row['error_code']) > -1)
                                ? <button type="button" className="btn btn-sm btn-danger btn-uppercase" id="fix" onClick={handleFix ? () => handleFix(row) : null}>Fix</button>
                                : row['error_code'] && row['error_code'] !== null && (["617"].indexOf(row['error_code']) > -1)
                                    ? <Link to={`/adminpanel/v2/view_connection_data/${DBName}/${tableName}/${connectionId}`} target="_blank">Go to Folder</Link>
                                    : <span>-</span>
                            : <Link to={`/adminpanel/v2/view_connection_data/${DBName}/${tableName}/${connectionId}`} target="_blank">Go to Folder</Link>}
                    </>
                } else if (row['category'] === "Data Quality Report" || row['category'] === "Download PDF report directly" || row['category'] === "Generate Report") {
                    return <>
                        <a type="button" className="btn btn-sm" style={{ color: "#0168fa" }} id="download" onClick={handleDownload ? () => handleDownload(row) : null}>Download</a>
                    </>
                } else {
                    return <>
                        <Link to={`/admin/datasets`} target="_blank">Go to Datasets</Link>
                    </>
                }
            }
        }
    ]
    let displayData = {
        tableData: requestData ? requestData : null,
        columnData: columnData
    }
    // let mgbtm = screen_width < mobile_width ? "-10px":"-6px" 
    return requestData ?
        <>
            <div className="d-flex justify-content-start align-items-center">
                <button className="btn btn-white btn-sm mg-r-10 mg-b-20" type="button" style={{height:"37px"}}onClick={() => refershButtonEvent()}>
                    <i className="fa fa-sync" aria-hidden="true"></i>
                </button>
                <div className="" style={{marginTop:"-12px", width:"125px"}}>
                    <Form label_array={formData} handle_form_drop_down={handleChange} />
                </div>
            </div>
            <DataTableComponent tableData={displayData.tableData} columnData={displayData.columnData} paginationStatus={true} />
            {displayModal}
        </> :
        <LoadingComponent />;
}

function mapStateToProps(state) {
    // return { authData: state.dataSet.authData };
    return { authData: { ...state.dataSet.authData, ...{ "toolId": state.dataSet.dataSet.toolId } } };
}

export default connect(mapStateToProps, null)(APIRequest);